/**
 * Provides props for a modal to accept either:
 * - An array of lang keys.
 * - A custom piece of text.
 * - and/or a custom piece of HTML
 * to display in the body of the modal as an informational message to the user.
 *
 * A component that uses this should display all of the things provided, not use an if/else.
 */
export const DialogTextPropsMixin = {
    props: {
        /**
         * A single lang key to display, or an array of lang keys.
         * Each one will be displayed in its own <p> tag.
         */
        textLangKeys: {
            type: [String, Array],
            default: null,
        },

        /**
         * A single piece of text to display escaped, or an array of text strings to display escaped.
         * Each one will be displayed in its own <p> tag.
         */
        customText: {
            type: [String, Array],
            default: null,
        },

        /**
         * A custom HTML string to display raw.
         */
        customHtml: {
            type: String,
            default: null,
        },
    },
};
